import anime from 'animejs/lib/anime.es.js';
import { mergeOptions } from '../../helpers/common/merge-options';

export interface CounterOptions {
	counterClass: string;
	dataFromSelector: string;
	dataToSelector: string;
	easing: string;
	round: number;
	duration: number;
}

export class Counter {
	static options: CounterOptions = {
		counterClass: '.js-counter-item',
		dataFromSelector: 'data-from-count',
		dataToSelector: 'data-to-count',
		easing: 'easeInOutSine',
		round: 1,
		duration: 500,
	};

	private options: CounterOptions;

	constructor(public element: HTMLElement, options?: Partial<CounterOptions>) {
		this.options = mergeOptions(Counter, options, element);
		const counters = document.querySelectorAll<HTMLElement>(this.options.counterClass);

		const observerOptions = {
			root: null,
			rootMargin: '0px',
			threshold: 1
		}

		if (typeof IntersectionObserver != 'undefined') {
			const observer = new IntersectionObserver(this.onIntersect, observerOptions);
			counters.forEach((counter) => {
				observer.observe(counter);
			});
		} else {
			counters.forEach(counter => counter.innerHTML = counter.getAttribute('data-to-count') || '')
		}
	}

	onIntersect = (entries: IntersectionObserverEntry[]) => {
		entries.forEach(entry => {
			this.triggerAnimation(entry.target);
		})
	}

	triggerAnimation = (counter: Element) => {
		const from = parseFloat(counter.getAttribute('data-from-count') || '0');
		const to = parseFloat(counter.getAttribute('data-to-count') || '100');

		anime({
			targets: counter,
			innerHTML: [from, to],
			easing: this.options.easing,
			round: this.options.round,
			duration: this.options.duration,
		})
	}
}
